// Izobraževalno-prodajni članek za potencialne najemnike prostora na kupish.si.
// Tema: pravni in logistični okvir spletne prodaje v Sloveniji.

export const pravniVodnikArticle = {
  slug: "pravni-vodnik-za-spletno-prodajo",
  title: "Pravni in logistični vodnik za spletno prodajo v Sloveniji",
  section: "unikatne-vsebine" as const,
  date: "2026-09-06 11:00:00",
  excerpt:
    "Kaj morate urediti, preden objavite prvi izdelek: registracija dejavnosti, računi, obvezni podatki, pravica do odstopa v 14 dneh, reklamacije, varstvo podatkov in dostava.",
  content: `
<p>Največ ljudi, ki ima dober izdelek, ne odlaša zaradi cene ali tehnike, temveč zaradi birokracije. Kaj moram registrirati? Kdaj izdam račun? Kaj če kupec vrne izdelek? Kaj moram objaviti na strani, da ne bom kaznovan?</p>

<p>Ta vodnik pojasnjuje pravni in logistični okvir spletne prodaje v Sloveniji v razumljivem jeziku — in pokaže, kaj lahko namesto vas prevzame urejena platforma. Vodnik je splošno pojasnilo, ne pravni nasvet; za konkretno situacijo se posvetujte z računovodjo ali pravnikom.</p>

<h2>1. Registracija dejavnosti</h2>

<p>Prodaja izdelkov na spletu je pridobitna dejavnost. Preden začnete redno prodajati, potrebujete registriran subjekt. V praksi sta najpogostejša:</p>

<ul>
<li><strong>Samostojni podjetnik (s. p.)</strong> — najhitrejša in najcenejša oblika; podjetnik odgovarja z vsem svojim premoženjem.</li>
<li><strong>Družba z omejeno odgovornostjo (d. o. o.)</strong> — ločeno premoženje in odgovornost, zahtevnejše vodenje.</li>
</ul>

<p>Za tiste, ki poleg zaposlitve prodajajo v manjšem obsegu, je pogosta izbira <strong>popoldanski s. p.</strong> z nižjimi mesečnimi prispevki. Pri izbiri se posvetujte z računovodjo — davčna osnova, prispevki in možnost normiranih odhodkov se med oblikami bistveno razlikujejo.</p>

<p>Ob registraciji izberete ustrezno šifro dejavnosti za spletno prodajo in odprete poslovni račun.</p>

<h2>2. Računi in davki</h2>

<ul>
<li><strong>Za vsako prodajo izdate račun</strong> z vsemi obveznimi sestavinami: podatki izdajatelja, kupca, opis blaga, količina, cena, datum in zaporedna številka.</li>
<li><strong>Davčno potrjevanje računov</strong> velja za gotovinsko poslovanje. Pri plačilu z nakazilom na poslovni račun potrjevanje praviloma ni potrebno; pri plačilu po povzetju in pri kartičnih plačilih preverite obveznost z računovodjo.</li>
<li><strong>DDV.</strong> Dokler ne presežete zakonskega praga obdavčljivega prometa, vam v sistem DDV ni treba vstopiti. Ob prodaji v druge države EU veljajo posebna pravila.</li>
<li><strong>Hramba dokumentacije.</strong> Račune, dobavnice in dokazila o pošiljanju hranite v zakonsko določenem roku.</li>
</ul>

<h2>3. Obvezni podatki na spletni strani</h2>

<p>Kupec mora pred nakupom brez iskanja najti:</p>

<ul>
<li>polno firmo, sedež, davčno in matično številko prodajalca;</li>
<li>elektronski naslov in način hitrega stika;</li>
<li>bistvene lastnosti izdelka;</li>
<li>končno ceno z vključenim davkom in <strong>vse stroške dostave</strong>;</li>
<li>načine plačila in dostave ter predviden rok dobave;</li>
<li>pojasnilo o pravici do odstopa in obrazec oziroma postopek;</li>
<li>opis reklamacijskega postopka in podatke o jamstvu;</li>
<li>pogoje poslovanja in politiko zasebnosti.</li>
</ul>

<p><strong>Najpogostejša napaka:</strong> cena dostave, ki se pokaže šele v zadnjem koraku nakupa. Poleg tega, da moti kupca, je nasprotna zahtevi po vnaprejšnji seznanitvi s stroški.</p>

<h2>4. Pravica do odstopa v 14 dneh</h2>

<p>Pri prodaji potrošniku ima kupec pravico, da v 14 dneh od prejema izdelka odstopi od nakupa <strong>brez navedbe razloga</strong>.</p>

<ul>
<li>Rok začne teči z dnem prevzema blaga.</li>
<li>Kupec mora odstop sporočiti; blago vrne v nadaljnjih 14 dneh.</li>
<li>Stroške vračila lahko nosi kupec, če ste ga o tem jasno obvestili vnaprej.</li>
<li>Prodajalec vrne prejeta plačila, vključno s stroški osnovne dostave, brez nepotrebnega odlašanja.</li>
<li>Kupec sme izdelek preizkusiti tako, kot bi ga v trgovini — ne pa uporabljati.</li>
</ul>

<h3>Kdaj pravica do odstopa ne velja</h3>

<ul>
<li>izdelki, izdelani po natančnih navodilih kupca ali prilagojeni njegovim potrebam;</li>
<li>hitro pokvarljivo blago;</li>
<li>zapečateni izdelki, ki jih zaradi zdravstvenih ali higienskih razlogov ni mogoče vrniti, če je pečat odprt;</li>
<li>zapečateni nosilci zvoka in slike ter računalniški programi z odprtim pečatom.</li>
</ul>

<p>Če prodajate izdelke po naročilu, to <strong>jasno navedite pri izdelku</strong>, ne le v pogojih poslovanja.</p>

<h2>5. Jamstvo in reklamacije</h2>

<p>Prodajalec odgovarja za skladnost blaga s pogodbo. Če ima izdelek napako, ima kupec pravico zahtevati odpravo napake, zamenjavo, znižanje cene ali odstop od pogodbe, po zakonsko določenem vrstnem redu.</p>

<ul>
<li>Reklamacijo rešujete <strong>vi</strong>, tudi kadar je izdelek poslal dobavitelj.</li>
<li>Na reklamacijo odgovorite v razumnem roku in pisno.</li>
<li>Če za izdelek velja garancija proizvajalca, kupcu priložite garancijski list in navodila v slovenščini, kjer so obvezna.</li>
<li>Vodite evidenco reklamacij — pomaga pri sporih in pri izbiri dobaviteljev.</li>
</ul>

<h2>6. Varstvo osebnih podatkov</h2>

<p>Ob vsakem naročilu obdelujete osebne podatke, zato veljajo pravila splošne uredbe o varstvu podatkov:</p>

<ul>
<li>zbirajte le podatke, ki jih za izvedbo naročila resnično potrebujete;</li>
<li>imejte objavljeno politiko zasebnosti, ki pojasni namen in rok hrambe;</li>
<li>za e-novice pridobite ločeno privolitev in omogočite enostavno odjavo;</li>
<li>posredovanje naslova dobavitelju ali dostavni službi mora biti pojasnjeno;</li>
<li>podatke hranite varno in jih ne uporabljajte za namene, o katerih kupec ni obveščen.</li>
</ul>

<h2>7. Logistika: dostava, embalaža, vračila</h2>

<h3>Dostava</h3>

<p>Izberite ponudnika glede na tip izdelka in ne le na ceno. Za manjše pakete so ključni razumna cena, sledenje pošiljke in mreža prevzemnih mest. Pri kosovnih izdelkih preverite pogoje pri poškodovanih pošiljkah.</p>

<p>Pri vsakem izdelku navedite ceno dostave in predviden rok. Rok raje ocenite previdno — zamuda je najpogostejši razlog za slabo mnenje.</p>

<h3>Embalaža</h3>

<ul>
<li>Zaščita mora ustrezati izdelku; poškodovan izdelek je dražji od boljše embalaže.</li>
<li>V paket priložite račun in obvestilo o odstopu od nakupa.</li>
<li>Preprosto in urejeno pakiranje krepi vtis resnosti — brez dragih dodatkov.</li>
</ul>

<h3>Vračila</h3>

<ul>
<li>Vnaprej določite naslov za vračila in kdo krije stroške.</li>
<li>Pripravite kratek obrazec, da kupcu ni treba ugibati.</li>
<li>Vrnjeno blago pregledajte in vračilo denarja izvedite hitro — hitro vračilo pogosto pomeni ponovni nakup.</li>
</ul>

<h2>8. Pošteno oglaševanje</h2>

<p>Pri prikazu popustov velja pravilo, da mora biti navedena tudi najnižja cena v obdobju pred znižanjem. Izogibajte se izmišljenim prihrankom, lažnim zalogam in odštevalnikom, ki se vsak dan ponastavijo. Poleg tveganja za kazen tovrstne prakse najbolj škodijo prav manjšim prodajalcem, ki živijo od zaupanja.</p>

<h2>Kaj od tega prevzame platforma</h2>

<p>Del obveznosti je vezan na vas kot prodajalca in vam jih nihče ne more odvzeti: registracija dejavnosti, izdajanje računov, jamstvo za blago in reševanje reklamacij.</p>

<p>Del pa je vezan na okolje, v katerem prodajate. Če najamete prostor na <a class="decorated-link" href="/">kupish.si</a>, dobite:</p>

<ul>
<li>urejeno strukturo strani izdelka s prostorom za obvezne podatke, ceno, dostavo in rok;</li>
<li>objavljene pogoje poslovanja in politiko zasebnosti spletnega nakupovalnega središča;</li>
<li>varno gostovanje, varnostni certifikat in vzdrževanje;</li>
<li>enotno predstavitev, ki kupcu pove, kje najde podatke o prodajalcu;</li>
<li>možnost, da poštnino in pogoje dostave nastavite sami.</li>
</ul>

<p>Z drugimi besedami: skrbeti morate za svoje poslovanje, ne pa še za tehnično in vsebinsko infrastrukturo spletne trgovine.</p>

<h2>Kontrolni seznam pred prvo objavo</h2>

<ol>
<li>Registrirana dejavnost in odprt poslovni račun.</li>
<li>Dogovor z računovodjo glede računov, DDV in evidenc.</li>
<li>Podatki o podjetju vidni kupcu.</li>
<li>Cene z davkom in jasno navedena dostava.</li>
<li>Pojasnilo o odstopu v 14 dneh in postopek vračila.</li>
<li>Opis reklamacijskega postopka.</li>
<li>Politika zasebnosti in privolitev za e-novice.</li>
<li>Izbran ponudnik dostave in preizkušena embalaža.</li>
<li>Pripravljena besedila za potrditev naročila, odpremo in vračilo.</li>
<li>Preizkusno naročilo, ki ga opravite sami od začetka do konca.</li>
</ol>

<h2>Kaj pomeni prodaja kupcem iz drugih držav EU</h2>

<p>Spletna prodaja ne pozna meje, zakonodaja pa jo. Če prodajate potrošnikom v drugih državah članicah, upoštevajte naslednje:</p>

<ul>
<li><strong>Pravice potrošnikov</strong> so v EU večinoma poenotene, zato pravica do odstopa v 14 dneh velja tudi za tuje kupce.</li>
<li><strong>Obračun DDV</strong> se pri čezmejni prodaji potrošnikom po preseganju skupnega evropskega praga presoja po državi kupca; za ureditev se posvetujte z računovodjo.</li>
<li><strong>Jezik in podatki.</strong> Če ciljno nagovarjate tuj trg, morajo biti bistveni podatki razumljivi tamkajšnjemu kupcu.</li>
<li><strong>Dostava in vračila.</strong> Vnaprej določite ceno pošiljanja v tujino in naslov za vračila, sicer stroški hitro pojedo maržo.</li>
</ul>

<p>Če šele začenjate, je najbolj smiselno začeti na domačem trgu in tujino dodati takrat, ko postopki že tečejo gladko.</p>

<h2>Dokumenti, ki jih pripravite enkrat in uporabljate vedno</h2>

<p>Velik del bremena izgine, ko naredite mapo s pripravljenimi dokumenti in besedili. Priporočamo:</p>

<ol>
<li><strong>Pogoji poslovanja</strong> z opisom naročanja, plačila, dostave, odstopa in reklamacij.</li>
<li><strong>Politika zasebnosti</strong> z nameni obdelave in roki hrambe.</li>
<li><strong>Obrazec za odstop od nakupa</strong>, ki ga priložite paketu ali pošljete po e-pošti.</li>
<li><strong>Predloga odgovora na reklamacijo</strong> — vljudna, jasna, z rokom rešitve.</li>
<li><strong>Predloge sporočil</strong> za potrditev naročila, obvestilo o odpremi in obvestilo o zamudi.</li>
<li><strong>Evidenca reklamacij in vračil</strong> z datumi, izdelki in razpletom.</li>
</ol>

<p>Ta priprava vzame en delovni dan, prihrani pa vsako naslednje leto več deset ur — in prepreči napake, ki nastanejo, ko odgovarjate na hitro in pod pritiskom.</p>

<h2>Najpogostejše napake, ki povzročijo spore</h2>

<ul>
<li><strong>Rok dobave, ki je preveč optimističen.</strong> Bolje obljubiti pet dni in dostaviti v treh kot obratno.</li>
<li><strong>Pogoji poslovanja, prepisani od drugega prodajalca.</strong> Če ne ustrezajo vašemu poslovanju, vas ne ščitijo.</li>
<li><strong>Nejasen postopek vračila.</strong> Kupec, ki ne ve, kam poslati paket, se pritoži namesto, da bi vrnil.</li>
<li><strong>Odgovarjanje na reklamacijo z zamudo.</strong> Večina sporov nastane zaradi molka, ne zaradi napake izdelka.</li>
<li><strong>Manjkajoč račun v paketu.</strong> Kupec ga potrebuje za uveljavljanje pravic in za svojo evidenco.</li>
</ul>

<p>Vse naštete napake so brezplačne za odpravo — potrebujete le urejene postopke in dosleden odziv.</p>

<h2>Pogosta vprašanja</h2>

<h3>Ali lahko prodajam brez registrirane dejavnosti?</h3>
<p>Redna prodaja z namenom pridobivanja dohodka zahteva registrirano dejavnost. Za svojo situacijo se posvetujte z računovodjo.</p>

<h3>Ali moram v sistem DDV?</h3>
<p>Ne takoj. Vstop je obvezen ob preseganju zakonskega praga prometa, prej pa je prostovoljen.</p>

<h3>Kdo plača vračilo izdelka?</h3>
<p>Neposredne stroške vračila lahko nosi kupec, če ste ga o tem jasno obvestili pred nakupom. Sicer jih nosite vi.</p>

<h3>Kaj, če izdelek pošlje dobavitelj?</h3>
<p>Za kupca ste prodajalec vi. Reklamacijo, vračilo in jamstvo urejate vi, razmerje z dobaviteljem pa je vaša notranja zadeva.</p>

<h2>Zaključek</h2>

<p>Pravila spletne prodaje niso zapletena — le številna so. Ko jih enkrat uredite, postanejo del rutine, kupcu pa dajejo prav tisto, kar ga prepriča: občutek, da ve, s kom posluje.</p>

<p>Če želite začeti brez skrbi za tehnično plat, si oglejte pogoje na strani <a class="decorated-link" href="/najem-spletne-trgovine">Najem spletne trgovine</a>, uredite <a class="decorated-link" href="/placilo-najemnine">plačilo najemnine</a> in preberite še <a class="decorated-link" href="/clanek/kako-pridobiti-kupce-v-spletno-trgovino">Kako pridobiti kupce v spletno trgovino</a>.</p>
`,
};
